import React, {useEffect, useState} from 'react'
import {Card, Col, Divider, Row, Space, Tag, Typography} from "antd";
import {useSearchParams} from "react-router-dom";
import {NewsApi} from "../../services/NewsApi";
import {ValueUtils} from "../../utils/ValueUtils";
import {Constants} from "../../utils/ConstantsUtils";
import SimpleTips from "../../containers/SimpleTips";

const NewsPage = () => {
    const [searchParams] = useSearchParams()
    const sid = searchParams.get('sid')

    const [news, setNews] = useState({})
    const [keywords, setKeywords] = useState({})

    useEffect(() => {
        NewsApi.getNews(sid)
            .onSuccess(setNews)

        NewsApi.getKeywords(sid)
            .onSuccess(setKeywords)
    }, []);

    return (
        <>
            <Row gutter={{lg: 16, sm: 0}}>
                <Col lg={16} xs={24}>
                    <Card>
                        <Typography>
                            <Typography.Title level={5}>
                                {news.title}
                            </Typography.Title>
                            <SimpleTips
                                tips={[
                                    Constants.newsEmotion(news.emotion),
                                    ValueUtils.formatDateOrEmpty(news.publishTime, 'YYYY-MM-DD HH:mm:ss'),
                                    news.source,
                                    news.author
                                ]}
                            />
                            <Divider/>
                            <div className="news" style={{whiteSpace: 'pre-wrap'}}
                                 dangerouslySetInnerHTML={{__html: news.content || news.contentAbstract}}>
                            </div>
                        </Typography>
                    </Card>
                </Col>
                <Col lg={8} xs={24}>
                    <Card>
                        <h5>关键词</h5>
                        <Space>
                            <Tag>{news.keyword}</Tag>
                        </Space>
                        <Divider/>

                        <h5>人物标签</h5>
                        {
                            keywords[1] &&
                            <Space wrap>
                                {keywords[1].map(k => <Tag>{k.keyword}</Tag>)}
                            </Space>
                        }
                        {
                            !keywords[1] &&
                                <Typography.Text type="secondary">
                                    暂无
                                </Typography.Text>
                        }
                        <Divider/>

                        <h5>机构标签</h5>
                        {
                            keywords[3] &&
                            <Space wrap>
                                {keywords[3].map(k => <Tag>{k.keyword}</Tag>)}
                            </Space>
                        }
                        {
                            !keywords[3] &&
                            <Typography.Text type="secondary">
                                暂无
                            </Typography.Text>
                        }
                        <Divider/>

                        <h5>地点标签</h5>
                        {
                            keywords[2] &&
                            <Space wrap>
                                {keywords[2].map(k => <Tag>{k.keyword}</Tag>)}
                            </Space>
                        }
                        {
                            !keywords[2] &&
                            <Typography.Text type="secondary">
                                暂无
                            </Typography.Text>
                        }

                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default NewsPage